/**
 * @fileoverview Byte arrays typed for Blob, Response and Web Crypto
 *
 * Purpose: since TypeScript 5.9 the DOM types accept only byte views backed
 * by a plain `ArrayBuffer` (`BufferSource`, `BlobPart`), while a bare
 * `Uint8Array` may sit on a `SharedArrayBuffer`. pdf-lib, JSZip and the mail
 * parser all return bare `Uint8Array`s, so their output needs narrowing before
 * it reaches `new Blob(...)` or `ctx.storage.store(...)`.
 *
 * Linear: MOR-2786
 */

/**
 * `bytes` as an `ArrayBuffer`-backed view. Re-wraps the same memory when the
 * buffer is a plain `ArrayBuffer`, as everything here produces; copies only
 * when it is a `SharedArrayBuffer`.
 */
export function arrayBufferBytes(bytes: Uint8Array): Uint8Array<ArrayBuffer> {
  const { buffer } = bytes;
  return buffer instanceof ArrayBuffer
    ? new Uint8Array(buffer, bytes.byteOffset, bytes.byteLength)
    : bytes.slice();
}
